import { Typography } from '@mui/material';

function ListboxComponent({ children, ...restProps }: React.HTMLAttributes<HTMLElement>) {
    return (
        <>
            <Typography component="span" variant="caption" sx={{ display: 'block', color: 'cement.500', px: 2, pt: 2 }}>
                Suggestions
            </Typography>
            <ul {...restProps}>{children}</ul>
        </>
    );
}

export default ListboxComponent;
